import React from 'react'
import SingleSelect from './SingleSelect'
import styled from 'styled-components'
import { NestedDropdown } from 'mui-nested-menu'
import { LOCATION_LABELS } from '../utils/const'
import { useMediaQuery } from 'react-responsive'
import { useTranslation } from 'gatsby-plugin-react-i18next'

const Box = styled.div`
  width: 350px;
  margin-bottom: 1rem;
`
const MenuBox = styled.div`
  width: 420px;
  margin-bottom: 1rem;
`
const SelectRegion = ({
  reg,
  setReg,
  whoOptions,
  incOptions,
  uniOptions,
  sectionId
}) => {
  const { t } = useTranslation()
  const WHO_OPTIONS = [
    {
      id: 'AFR',
      label: t('African Region'),
      callback: (event, item) => setReg('AFR')
    },
    {
      id: 'EMR',
      label: t('Eastern Mediterranean Region'),
      callback: (event, item) => setReg('EMR')
    },
    {
      id: 'EUR',
      label: t('European Region'),
      callback: (event, item) => setReg('EUR')
    },
    {
      id: 'AMR',
      label: t('Region of the Americas'),
      callback: (event, item) => setReg('AMR')
    },
    {
      id: 'SEAR',
      label: t('South-East Asian Region'),
      callback: (event, item) => setReg('SEAR')
    },
    {
      id: 'WPR',
      label: t('Western Pacific Region'),
      callback: (event, item) => setReg('WPR')
    }
  ]

  const INC_OPTIONS = [
    {
      id: 'WBLIC',
      label: t('Low Income'),
      callback: (event, item) => setReg('WBLIC')
    },
    {
      id: 'WBLMIC',
      label: t('Low-Middle Income'),
      callback: (event, item) => setReg('WBLMIC')
    },
    {
      id: 'WBUMIC',
      label: t('Upper-Middle Income'),
      callback: (event, item) => setReg('WBUMIC')
    },
    {
      id: 'WBHIC',
      label: t('High Income'),
      callback: (event, item) => setReg('WBHIC'),
      disabled: sectionId === '2.2' //IG2.2
    }
  ]
  const UNI_OPTIONS = [
    {
      id: 'EAPR',
      label: t('East Asia and Pacific Region'),
      callback: (event, item) => setReg('EAPR')
    },
    {
      id: 'ESAR',
      label: t('Eastern and Southern Africa Region'),
      callback: (event, item) => setReg('ESAR')
    },
    {
      id: 'ECAR',
      label: t('Europe and Central Asia Region'),
      callback: (event, item) => setReg('ECAR')
    },
    {
      id: 'LACR',
      label: t('Latin America and the Caribbean Region'),
      callback: (event, item) => setReg('LACR')
    },
    {
      id: 'MENA',
      label: t('Middle East and North Africa Region'),
      callback: (event, item) => setReg('MENA')
    },
    {
      id: 'ROSA',
      label: t('South Asia Region'),
      callback: (event, item) => setReg('ROSA')
    },
    {
      id: 'WCAR',
      label: t('West and Central Africa Region'),
      callback: (event, item) => setReg('WCAR')
    }
  ]
  const globalOnly = ['5.1', '6.1', '6.2', '6.3']
  const menuItemsData = {
    label: reg === 'GBL' ? t('Global — All Regions') : t(LOCATION_LABELS[reg]),
    items: [
      {
        label: t('Global — All Regions'),
        callback: (event, item) => setReg('GBL')
      },

      {
        label: t('WHO Regions'),
        items: [...WHO_OPTIONS],
        sx: { width: '300px' }
      },
      {
        label: t('UNICEF Programme Regions'),
        items: [...UNI_OPTIONS],
        sx: { width: '300px' }
      },
      {
        label: t('World Bank Income Classification'),
        items: [...INC_OPTIONS],
        sx: { width: '300px' }
      }
    ]
  }

  const globalMenuItemsData = {
    label: reg === 'GBL' ? t('Global — All Regions') : t(LOCATION_LABELS[reg]),
    items: [
      {
        label: t('Global — All Regions'),
        callback: (event, item) => setReg('GBL')
      }
    ]
  }
  const matches = useMediaQuery({ query: '(max-width: 740px)' })

  return (
    <>
      {matches ? (
        <Box>
          <SingleSelect
            whoOptions={whoOptions}
            incOptions={incOptions}
            uniOptions={uniOptions}
            value={reg}
            onChange={setReg}
          />
        </Box>
      ) : (
        <MenuBox>
          <NestedDropdown
            menuItemsData={
              globalOnly.includes(sectionId)
                ? globalMenuItemsData
                : menuItemsData
            }
            MenuProps={{ elevation: 3 }}
            ButtonProps={{ variant: 'outlined' }}
          />
        </MenuBox>
      )}
    </>
  )
}

export default SelectRegion
